// extracted by mini-css-extract-plugin
export default {"defaultIcon":"customEmpty_defaultIcon__iyJS1"};